<div class="satellite-timeline">
  <button
    type="button"
    class="timeline-nav prev"
    (click)="scrollPrev()"
    [attr.aria-label]="'Previous' | translate">
    <i class="pi pi-chevron-left"></i>
  </button>

  <div #strip class="timeline-strip" (scroll)="onStripScroll()">
    @if (loading && dates.length === 0) {
      <div class="timeline-loading">
        <span class="timeline-spinner"></span>
        <span class="timeline-loading-text">{{ 'Loading' | translate }}</span>
      </div>
    } @else if (dates.length === 0) {
      <div class="timeline-empty">{{ 'No dates available' | translate }}</div>
    } @else {
      @for (group of stripGroups; track $index) {
        @if (group.type === 'range') {
          <div class="timeline-range-track">
            @for (entry of group.entries; track trackByDate($index, entry)) {
              <button
                type="button"
                class="timeline-chip"
                [attr.data-date]="entry.date"
                [class.in-range]="true"
                [class.range-start]="isRangeStart(entry.date)"
                [class.range-end]="isRangeEnd(entry.date)"
                (click)="onChipClick(entry)">
                <span class="chip-label">{{ formatLabel(entry) }}</span>
                @if (entry.hasClouds) {
                  <i class="pi pi-cloud chip-cloud"></i>
                }
              </button>
            }
          </div>
        } @else {
          @for (entry of group.entries; track trackByDate($index, entry)) {
            <button
              type="button"
              class="timeline-chip"
              [attr.data-date]="entry.date"
              (click)="onChipClick(entry)">
              <span class="chip-label">{{ formatLabel(entry) }}</span>
              @if (entry.hasClouds) {
                <i class="pi pi-cloud chip-cloud"></i>
              }
            </button>
          }
        }
      }
    }
  </div>

  @if (showAllButton) {
    <button
      type="button"
      class="timeline-chip timeline-all-btn"
      [class.all-active]="allModeActive"
      (click)="onAllClick()">
      <span class="chip-label">{{ 'All' | translate }}</span>
    </button>
  }

  <button
    type="button"
    class="timeline-nav next"
    (click)="scrollNext()"
    [attr.aria-label]="'Next' | translate">
    <i class="pi pi-chevron-right"></i>
  </button>

  @if (loading && dates.length > 0) {
    <span class="timeline-spinner inline"></span>
  }
</div>
